import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PipeModule } from 'src/core-lib/pipes/pipe.module';
import { VarModule } from 'src/core-lib/var/var.module';
import { TagManagerModule } from 'src/externals/tag-manager/tag-manager.module';
import { MediaModule } from 'src/layout/media/media.module';
import { CustomizerComponent } from './components/customizer/customizer.component';

@NgModule({
    declarations: [

    ],
    imports: [
        CustomizerComponent,
        CommonModule,
        TranslateModule,
        ReactiveFormsModule,
        MediaModule,
        PipeModule,
        VarModule,
        TagManagerModule,
    ],
    exports: [
        CustomizerComponent,
    ]
})
export class CustomizerModule {}
